// extracted by mini-css-extract-plugin
export var activeDot = "_53-c";
export var buttonContainer = "_53-9";
export var channelButton = "_53-a";
export var clickable = "_53-d";
export var content = "_53-0";
export var contentFull = "_53-2";
export var contentThird = "_53-1";
export var contentWrapper = "_53-7";
export var description = "_53-5";
export var heightShort = "_53-f";
export var image = "_53-3";
export var imageContainer = "_53-4";
export var selectButton = "_53-e";
export var spinnerContainer = "_53-b";
export var titleContent = "_53-8";
export var titleWrapper = "_53-6";